// Action column for each contact in the contact list
import React from 'react';
import { Flex } from 'antd';
import { MDropdown } from '@Components/Base';
import { MoreOutlined } from '@ant-design/icons';
import { ReactComponent as ViewIcon } from '@Icons/additional/eye.svg';
import { Contact } from '../types';

interface ContactActionColumnProps {
  contact: Contact;
  onView?: (contact: Contact) => void;
  onEdit?: (contact: Contact) => void;
}

const ContactActionColumn: React.FC<ContactActionColumnProps> = ({
  contact,
  onView,
  // eslint-disable-next-line
  onEdit,
}) => {
  const items = [
    {
      key: 'view',
      label: (
        <Flex className="trojan-action-item" onClick={() => onView?.(contact)}>
          <ViewIcon /> <span>View</span>
        </Flex>
      ),
      style: { padding: 0 },
    },
    // TODO: Edit contact feature is not available yet
    // {
    //   key: 'edit',
    //   label: (
    //     <Flex className="trojan-action-item" onClick={() => onEdit?.(contact)}>
    //       <EditIcon /> <span>Edit</span>
    //     </Flex>
    //   ),
    //   style: { padding: 0 },
    // },
  ];

  return (
    <MDropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <MoreOutlined style={{ cursor: 'pointer', fontSize: '16px' }} />
    </MDropdown>
  );
};

export default ContactActionColumn;
